
export const content = Object.values({
  "BU03450000": {
    buurten: ["BU03450000", "BU03450003"],
    title: "Koopcentrum, Achterkerk / Beatrixstraat en omgeving",
    content: `
### Wanneer?
Lange termijn.
### Waarom deze buurt?
In deze buurten staan veel oude gebouwen, van vóór 1930. Deze zijn vaak lastig te isoleren en op een duurzame warmtebron aan te sluiten.
### Wat gaat er gebeuren?
We wachten nog even voordat we deze buurten aanpakken. Eerst doen we ervaring op in de andere buurten, en kijken we hoe de techniek zich ontwikkelt. Misschien is in de toekomst duurzaam gas een goede optie, maar dat is nu nog niet zeker.
Wel kan alvast energie bespaard worden door woningen te isoleren. De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren hierbij te helpen.`
  },
  "BU03450101": {
    buurten: ["BU03450101"],
    title: "Dragonder-Zuid",
    content: `
### Wanneer?
We onderzoeken of deze buurt voor 2030 van het aardgas af kan.
### Waarom deze buurt?
Dit is een buurt met veel hoogbouw, de buurt lijkt daarom geschikt voor een warmtenet. Ook is het gunstig dat het aantal partijen overzichtelijk is: een groot deel is corporatiebezit en VvE’s. Er zijn kansen voor een gezamenlijk warmtenet met Dragonder-Oost
### Wat gaat er gebeuren?
Binnenkort start het onderzoek in de buurt, en maken we samen met bewoners en ondernemers uit de buurt een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. Daarin trekken we samen op met de omliggende buurten, zoals Dragonder-Oost. Daarna besluiten we of de buurt op de planning komt om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.`
  },
  "BU03450104": {
    buurten: ["BU03450104"],
    title: "Dragonder-Oost",
    content: `
### Wanneer?
We onderzoeken of deze buurt voor 2030 van het aardgas af kan.
### Waarom deze buurt?
Deze buurt ligt op een veelbelovende plek, naast het warmtenet van Veenendaal-Oost ligt. Misschien kan dat warmtenet uitgebreid worden tot in Dragonder-Oost. De woningen zijn gebouwd na 2002 en al goed geïsoleerd – die stap hoeft dus niet meer genomen te worden. Daardoor zijn ook warmtepompen een mogelijkheid. Een extra reden om naar deze buurt te kijken is dat het vervangingsmoment voor de CV-ketels bij veel huizen dichtbij is.
### Wat gaat er gebeuren?
Binnenkort start het onderzoek in de buurt, en maken we samen met bewoners en ondernemers uit de buurt een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. In dat onderzoek moet duidelijk worden of hier juist een warmtenet of oplossingen per woning of woongebouw het meest aantrekkelijk is. Daarna besluiten we of de buurt op de planning komt om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.`
  },
  "BU03450105": {
    buurten: ["BU03450105"],
    title: "Veenendaal-Oost (Buurtstede en Veenderij, Groenpoort in aanbouw)",
    content: `
### Wanneer?
We onderzoeken of deze buurten voor 2030 van het aardgas af kunnen.
### Waarom deze buurten?
In deze wijken ligt al een warmtenet van DEVO. Dit warmtenet wordt momenteel gevoed door een combinatie van bodemenergie, grootschalige warmtepompen en een warmtekrachtcentrale. De warmtekrachtcentrale gebruikt aardgas. Als hiervoor een andere, duurzame warmtebron wordt gevonden, is de buurt aardgasvrij. Het vraagt dus relatief weinig inspanning om deze buurt aardgasvrij te maken.
### Wat gaat er gebeuren?
DEVO (de eigenaar van het warmtenet) gaat onderzoeken of er een duurzame warmtebron mogelijk is voor het warmtenet, in plaats van aardgas. Als dit haalbaar en betaalbaar is, besluiten we definitief of de buurt vóór 2030 van het aardgas afgaat.`
  },
  "BU03450203": {
    buurten: ["BU03450203", "BU03450204"],
    title: "Petenbos en Petenbos-Oost",
    content: `
### Wanneer?
We onderzoeken of deze buurten voor 2030 (deels) van het aardgas af kunnen.
### Waarom deze buurten?
Dit zijn buurten waar oplossingen per woning het meest voor de hand liggen. De gemeente vindt het belangrijk om ervaring op te doen met de oplossingen per woning, en met het betrekken van een grote groep eigenaren van koopwoningen. Petenbos en Petenbos-Oost zijn gekozen omdat het grootste deel van de woningen hier energielabel B heeft. Ze zijn dus redelijk geïsoleerd. We denken voor deze buurten aan een stapsgewijze aanpak. De buurten gaan dan niet per se in zijn geheel voor 2030 van het aardgas af, maar wel een deel van de woningen.
### Wat gaat er gebeuren?
Binnenkort start het onderzoek in de buurten, en maken we samen met bewoners en ondernemers uit de buurten een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. Daarna besluiten we definitief of de buurten vóór 2030 (geheel of gedeeltelijk) van het aardgas afgaan. En welke warmtevoorziening er dan komt.`
  },
  "BU03450205": {
    buurten: ["BU03450205", "BU03450201", "BU03450405", "BU03450505", "BU03450404", "BU03450102"],
    title: "Nijverkamp, Het Ambacht, De Batterijen, De Faktorij en De Vendel, De Compagnie, De Compagnie-Oost",
    content: `
### Wanneer?
De planning voor de bedrijventerreinen en kantoorgebieden wordt later bepaald.
### Wat gaat er gebeuren?
De bedrijven- en kantorenterreinen vragen maatwerk, waarbij we bij elk bedrijf apart kijken wat er nodig is. Dit doen wij samen met de bedrijvenverenigingen.`
  },
  "BU03450301": {
    buurten: ["BU03450301"],
    title: "Franse Gat",
    content: `
### Wanneer?
We onderzoeken of deze buurt voor 2030 van het aardgas af kan.
### Waarom deze buurt?
De gemeente, Patrimonium en de Veenendaalse woningstichting werken al aan het verbeteren van deze wijk. Zij maken een gebiedsvisie met als doel een veilige, gezonde en groene wijk. De gebiedsvisie gaat in op de inrichting van straten, pleinen en parken, maar ook op energiebesparing en het voorbereiden op een aardgasvrije toekomst.
### Wat gaat er gebeuren?
Er is al een traject gestart in het Franse Gat. De komende tijd gaan we verder uitwerken van de toekomstige energievoorziening van de buurt, samen met bewoners en corporaties. Daarna besluiten we of de buurt op de planning komt om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.`
  },
  "BU03450400": { 
    buurten: ["BU03450400"],
    title: "Molenbrug en Duivenwal",
    content: `
### Wanneer?
We onderzoeken of deze buurten voor 2030 van het aardgas af kunnen.
### Waarom deze buurten?
Dit zijn buurten met veel hoogbouw. Meer dan de helft van de woningen is in het bezit van een woningcorporatie. Dit samen maakt dat de buurten geschikt lijken voor een warmtenet. Bovendien loopt er al een verduurzamingstraject bij een aantal VvE’s.
### Wat gaat er gebeuren?  
Binnenkort start het onderzoek in de buurten, en maken we samen met bewoners en ondernemers uit de buurten een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. Daarna besluiten we of de buurten op de planning komen om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.`
  },
  "BU03450402": {
    buurten: ["BU03450402", "BU03450002", "BU03450001", "BU03450300"],
    title: "De Pol, Stationswijk, Schrijverswijk,  Meesterweide",
    content: `
### Wanneer?
Middellange termijn. Huidige planning: na 2030.
### Waarom deze buurt?
Dit is een buurt waar een warmtenet de meest logische oplossing lijkt. Een warmtenet ontwikkel je niet in één keer. We beginnen daarom met een paar buurten (<a href="#verkenningswijken-kaart">verkenningswijken</a>) en breiden dan steeds verder uit. Zo kunnen we ook leren van ervaringen.
### Wat gaat er gebeuren?
Pas later, nadat in de verkenningswijken ervaring is opgedaan, wordt samen met bewoners een plan voor deze buurt gemaakt. Wel kunnen de woningen alvast voorbereid worden door ze te isoleren. Zo besparen we energie. De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren hierbij te helpen.
<h3><a class="anchor-link" id="verkenningswijken-kaart" name="verkenningswijken" tabindex="-1"></a>Verkenningswijken</h3>Er is nog niet besloten welke wijk als eerste overstapt op een nieuwe warmtevoorziening. &nbsp;We gaan in een aantal buurten meer onderzoek doen. Dit zijn de 'verkenningswijken': Petenbos en Petenbos-Oost, Franse Gat, Dragonder-Zuid, Dragonder-Oost, Molenbrug, Veenendaal-Oost (Buurtstede en Veenderij, Groenpoort in aanbouw).&nbsp;De komende tijd worden plannen gemaakt.`
  },
  "BU03450501": { 
    buurten: ["BU03450501", "BU03450502", "BU03450403", "BU03450202"],
    title: "Componistenbuurt, Vogelbuurt, De Gelderse Blom, Gezonken Hoek",
    content: `
### Wanneer?
Middellange termijn. Huidige planning: na 2030.
### Waarom deze buurt?
Dit is een buurt waar niet meteen duidelijk is wat beter is: een warmtenet of oplossingen per woning of flat. Daarom doen we eerst ervaring op in de verkenningswijken.
### Wat gaat er gebeuren?
Pas later, nadat in de verkenningswijken ervaring is opgedaan, wordt samen met bewoners een plan voor deze buurt gemaakt. Wel kunnen de woningen alvast voorbereid worden door ze te isoleren. Zo besparen we energie. De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren hierbij te helpen.`
  },
  "BU03450504": {
    buurten: ["BU03450500", "BU03450504", "BU03450503", "BU03450401", "BU03450100", "BU03450200"],
    title: "Pioniersbuurt, Dichtersbuurt, Schepenbuurt, ’t Hoorntje, Dragonder-Noord, Engelenburg",
    content: `
### Wanneer?
Middellange termijn. Huidige planning: na 2030.
### Waarom deze buurt?
In een deel van deze buurt lijkt een warmtenet de meest logische oplossing, in een ander deel oplossingen per woning/woongebouw. Een warmtenet ontwikkel je niet in één keer. We beginnen daarom met een paar buurten (<a href="#verkenningswijken-kaart">verkenningswijken</a>) en breiden dan steeds verder uit. Zo kunnen we ook leren van ervaringen.
### Wat gaat er gebeuren?
Pas later, nadat in de verkenningswijken ervaring is opgedaan, wordt samen met bewoners een plan voor deze buurt gemaakt. Wel kunnen de woningen alvast voorbereid worden door ze te isoleren. Zo besparen we energie. De gemeente zal de komende jaren een plan van aanpak ontwikkelen om woningeigenaren hierbij te helpen.
<h3><a class="anchor-link" id="verkenningswijken-kaart" name="verkenningswijken" tabindex="-1"></a>Verkenningswijken</h3>Er is nog niet besloten welke wijk als eerste overstapt op een nieuwe warmtevoorziening. &nbsp;We gaan in een aantal buurten meer onderzoek doen. Dit zijn de 'verkenningswijken': Petenbos en Petenbos-Oost, Franse Gat, Dragonder-Zuid, Dragonder-Oost, Molenbrug, Veenendaal-Oost (Buurtstede en Veenderij, Groenpoort in aanbouw).&nbsp;De komende tijd worden plannen gemaakt.`
  },
  "BU03450507": {
    buurten: ["BU03450507", "BU03450506", "BU03450302", "BU03450206", "BU03450207", "BU03450103", "BU03450208"],
    title: "Bezuiden de Dijkstraat, Fort aan de Buursteeg, Salamander, De Groene Velden, De Blauwe Hel, Hondzenelleboog, Spitsbergen",
    content: `
### Wanneer?
Tussen nu en 2050, in een natuurlijk tempo. Bijvoorbeeld door steeds aan te haken bij een verbouwing of verhuizing.
### Waarom deze buurt?
Dit zijn de buurten met veel vrijstaande huizen of twee-onder-een-kap woningen, en met veel koopwoningen. Hier liggen oplossingen per woning voor de hand. Dit maakt het mogelijk dat niet alle bewoners op hetzelfde moment van het gas af gaan.
### Wat gaat er gebeuren?
De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren te helpen bij de overstap op aardgasvrije warmte. Maatregelen kunnen stap voor stap genomen worden, bijvoorbeeld eerst isoleren en een paar jaar later een warmtepomp aanschaffen. Logische momenten om dat te doen zijn bij een verbouwing of een verhuizing.`
  }
}).reduce((result, item) => {
  item.buurten.forEach(buurt => result[buurt] = item)
  return result
}, {})

// Copy & paste from https://duurzaamveenendaal.nl/aardgasvrij/1661349.aspx?t=Wat-gebeurt-er-in-mijn-buurt- vanaf "Verkenningswijken"
export const screenreader = `

<h2><a class="anchor-link" id="verkenningswijken" name="verkenningswijken" tabindex="-1"></a>Verkenningswijken</h2>

<p>Er&nbsp;is nog niet besloten welke wijk als eerste overstapt op een nieuwe warmtevoorziening. &nbsp;We gaan in een aantal buurten meer onderzoek doen. Dit zijn de 'verkenningswijken': Petenbos en Petenbos-Oost, Franse Gat, Dragonder-Zuid, Dragonder-Oost, Molenbrug, Veenendaal-Oost (Buurtstede en Veenderij, Groenpoort in aanbouw).&nbsp;De komende tijd worden plannen gemaakt.</p>

<h2><a id="molenbrugduivenwal" name="Molenbrug_Duivenwal" tabindex="-1"></a>Molenbrug en Duivenwal</h2>

<h3>Wanneer?</h3>

<p>We onderzoeken of deze buurten voor 2030 van het aardgas af kunnen.</p>

<h3>Waarom deze buurten?</h3>

<p>Dit zijn buurten met veel hoogbouw. Meer dan de helft van de woningen is in het bezit van een woningcorporatie. Dit samen maakt dat de buurten geschikt lijken voor een warmtenet. Bovendien loopt er al een verduurzamingstraject bij een aantal VvE’s.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Binnenkort start het onderzoek in de buurten, en maken we samen met bewoners en ondernemers uit de buurten een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. Daarna besluiten we of de buurten op de planning komen om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.</p>

<h2><br>
<a id="franse_gat" name="Franse Gat" tabindex="-1"></a>Franse Gat</h2>

<h3>Wanneer?</h3>

<p>We onderzoeken of deze buurt voor 2030 van het aardgas af kan.</p>

<h3>Waarom deze buurt?</h3>

<p>De gemeente, Patrimonium en de Veenendaalse woningstichting werken al aan het verbeteren van deze wijk. Zij maken een gebiedsvisie met als doel een veilige, gezonde en groene wijk. De gebiedsvisie gaat in op de inrichting van straten, pleinen en parken, maar ook op energiebesparing en het voorbereiden op een aardgasvrije toekomst.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Er is al een traject gestart in het Franse Gat. De komende tijd gaan we verder uitwerken van de toekomstige energievoorziening van de buurt, samen met bewoners en corporaties. Daarna besluiten we of de buurt op de planning komt om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.</p>

<h2><a id="dragonderzuid" name="Dragonder-zuid" tabindex="-1"></a>Dragonder-Zuid</h2>

<h3>Wanneer?</h3>

<p>We onderzoeken of deze buurt voor 2030 van het aardgas af kan.</p>

<h3>Waarom deze buurt?</h3>

<p>Dit is een buurt met veel hoogbouw, de buurt lijkt daarom geschikt voor een warmtenet. Ook is het gunstig dat het aantal partijen overzichtelijk is: een groot deel is corporatiebezit en VvE’s. Er zijn kansen voor een gezamenlijk warmtenet met Dragonder-Oost</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Binnenkort start het onderzoek in de buurt, en maken we samen met bewoners en ondernemers uit de buurt een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. Daarin trekken we samen op met de omliggende buurten, zoals Dragonder-Oost. Daarna besluiten we of de buurt op de planning komt om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.</p>

<h2><br>
<a id="dragonderoost" name="Dragonder-oost" tabindex="-1"></a>Dragonder-Oost</h2>

<h3>Wanneer?</h3>

<p>We onderzoeken of deze buurt voor 2030 van het aardgas af kan.</p>

<h3>Waarom deze buurt?</h3>

<p>Deze buurt ligt op een veelbelovende plek, naast het warmtenet van Veenendaal-Oost ligt. Misschien kan dat warmtenet uitgebreid worden tot in Dragonder-Oost. De woningen zijn gebouwd na 2002 en al goed geïsoleerd – die stap hoeft dus niet meer genomen te worden. Daardoor zijn ook warmtepompen een mogelijkheid. Een extra reden om naar deze buurt te kijken is dat het vervangingsmoment voor de CV-ketels bij veel huizen dichtbij is.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Binnenkort start het onderzoek in de buurt, en maken we samen met bewoners en ondernemers uit de buurt een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. In dat onderzoek moet duidelijk worden of hier juist een warmtenet of oplossingen per woning of woongebouw het meest aantrekkelijk is. Daarna besluiten we of de buurt op de planning komt om vóór 2030 van het aardgas af te gaan. En welke warmtevoorziening er dan komt.</p>

<h2><a id="veenendaaloost" name="Veenendaal-oost" tabindex="-1"></a>Veenendaal-Oost (Buurtstede en Veenderij, Groenpoort in aanbouw)</h2>

<h3>Wanneer?</h3>

<p>We onderzoeken of deze buurten voor 2030 van het aardgas af kunnen.</p>

<h3>Waarom deze buurten?</h3>

<p>In deze wijken ligt al een warmtenet van DEVO. Dit warmtenet wordt momenteel gevoed door een combinatie van bodemenergie, grootschalige warmtepompen en een warmtekrachtcentrale. De warmtekrachtcentrale gebruikt aardgas. Als hiervoor een andere, duurzame warmtebron wordt gevonden, is de buurt aardgasvrij. Het vraagt dus relatief weinig inspanning om deze buurt aardgasvrij te maken.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>DEVO (de eigenaar van het warmtenet) gaat onderzoeken of er een duurzame warmtebron mogelijk is voor het warmtenet, in plaats van aardgas. Als dit haalbaar en betaalbaar is, besluiten we definitief of de buurt&nbsp;vóór 2030 van het aardgas afgaat.&nbsp;</p>

<h2><br>
<a id="petenbos" name="Petenbos" tabindex="-1"></a>Petenbos en Petenbos-Oost</h2>

<h3>Wanneer?</h3>

<p>We onderzoeken of deze buurten voor 2030 (deels) van het aardgas af kunnen.</p>

<h3>Waarom deze buurten?</h3>

<p>Dit zijn buurten waar oplossingen per woning het meest voor de hand liggen. De gemeente vindt het belangrijk om ervaring op te doen met de oplossingen per woning, en met het betrekken van een grote groep eigenaren van koopwoningen. Petenbos en Petenbos-Oost zijn gekozen omdat het grootste deel van de woningen hier energielabel B heeft. Ze zijn dus redelijk geïsoleerd. We denken voor deze buurten aan een stapsgewijze aanpak. De buurten gaan dan niet per se in zijn geheel voor 2030 van het aardgas af, maar wel een deel van de woningen.</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Binnenkort start het onderzoek in de buurten, en maken we samen met bewoners en ondernemers uit de buurten een plan. Buurtbewoners en ondernemers ontvangen hier een uitnodiging voor. Daarna besluiten we definitief of de buurten vóór 2030 (geheel of gedeeltelijk) van het aardgas afgaan. En welke warmtevoorziening er dan komt.</p>

<p>&nbsp;</p>

<h2><a class="anchor-link" id="ml_nog_niet_duidelijk" name="ML Nog niet duidelijk" tabindex="-1"></a>Componistenbuurt, Vogelbuurt, De Gelderse Blom, Gezonken Hoek</h2>

<h3>Wanneer?</h3>

<p>Middellange termijn. Huidige planning: na 2030.&nbsp;</p>

<h3>Waarom deze buurt?</h3>

<p>Dit is een buurt waar niet meteen duidelijk is wat beter is: een warmtenet of oplossingen per woning of flat. Daarom doen we eerst ervaring op in de verkenningswijken.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Pas later, nadat in de verkenningswijken ervaring is opgedaan, wordt samen met bewoners een plan voor deze buurt gemaakt. Wel kunnen de woningen alvast voorbereid worden door ze te isoleren. Zo besparen we energie. De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren hierbij te helpen.</p>

<h2><br>
<a class="anchor-link" id="ml_warmtenet" name="ML Warmtenet" tabindex="-1"></a>De Pol,&nbsp;Stationswijk,&nbsp;Schrijverswijk,&nbsp; Meesterweide</h2>

<h3>Wanneer?</h3>

<p>Middellange termijn. Huidige planning: na 2030.&nbsp;</p>

<h3>Waarom deze buurt?</h3>

<p>Dit is een buurt waar een warmtenet de meest logische oplossing lijkt. Een warmtenet ontwikkel je niet in één keer. We beginnen daarom met een paar buurten ("<a href="#verkenningswijken">verkenningswijken</a>")&nbsp;en breiden dan steeds verder uit. Zo kunnen we ook leren van ervaringen.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Pas later, nadat in de verkenningswijken ervaring is opgedaan, wordt samen met bewoners een plan voor deze buurt gemaakt. Wel kunnen de woningen alvast voorbereid worden door ze te isoleren. Zo besparen we energie. De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren hierbij te helpen.</p>

<h2><br>
<a class="anchor-link" id="ml_combi" name="ML Combi" tabindex="-1"></a>Pioniersbuurt,&nbsp;Dichtersbuurt,&nbsp;Schepenbuurt,&nbsp;’t Hoorntje,&nbsp;Dragonder-Noord,&nbsp;Engelenburg</h2>

<h3>Wanneer?</h3>

<p>Middellange termijn. Huidige planning: na 2030.&nbsp;</p>

<h3>Waarom deze buurt?</h3>

<p>In een deel van deze buurt lijkt een warmtenet de meest logische oplossing, in een ander deel oplossingen per woning/woongebouw. Een warmtenet ontwikkel je niet in één keer. We beginnen daarom met een paar buurten ("<a href="#verkenningswijken">verkenningswijken</a>")&nbsp;en breiden dan steeds verder uit. Zo kunnen we ook leren van ervaringen.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>Pas later, nadat in de verkenningswijken ervaring is opgedaan, wordt samen met bewoners een plan voor deze buurt gemaakt. Wel kunnen de woningen alvast voorbereid worden door ze te isoleren. Zo besparen we energie. De gemeente zal de komende jaren een plan van aanpak ontwikkelen om woningeigenaren hierbij te helpen.</p>

<h2><br>
<a class="anchor-link" id="lange_termijn" name="Lange termijn" tabindex="-1"></a>Koopcentrum, Achterkerk/Beatrixstraat en omgeving</h2>

<h3>Wanneer?</h3>

<p>Lange termijn.</p>

<h3>Waarom deze buurt?</h3>

<p>In deze buurten staan veel oude gebouwen, van vóór 1930. Deze zijn vaak lastig te isoleren en op een duurzame warmtebron aan te sluiten.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>We wachten nog even voordat we deze buurten aanpakken. Eerst doen we ervaring op in de andere buurten, en kijken we hoe de techniek zich ontwikkelt. Misschien is in de toekomst duurzaam gas een goede optie, maar dat is nu nog niet zeker.<br>
Wel kan alvast energie bespaard worden door woningen te isoleren. De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren hierbij te helpen.</p>

<h2><br>
<a class="anchor-link" id="natuurlijk_tempo" name="natuurlijk tempo" tabindex="-1"></a>Bezuiden de Dijkstraat, Fort aan de Buursteeg,&nbsp;Salamander,&nbsp;De Groene Velden,&nbsp;De Blauwe Hel,&nbsp;Hondzenelleboog,&nbsp;Spitsbergen<br>
<br>
Wanneer?</h2>

<p>Tussen nu en 2050, in een natuurlijk tempo. Bijvoorbeeld door steeds aan te haken bij een verbouwing of verhuizing.</p>

<h3>Waarom deze buurt?</h3>

<p>Dit zijn de buurten met veel vrijstaande huizen of twee-onder-een-kap woningen, en met veel koopwoningen. Hier liggen oplossingen per woning voor de hand. Dit maakt het mogelijk dat niet alle bewoners op hetzelfde moment van het gas af gaan.&nbsp;</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>De gemeente zal de komende jaren een aanpak ontwikkelen om woningeigenaren te helpen bij de overstap op aardgasvrije warmte. Maatregelen kunnen stap voor stap genomen worden, bijvoorbeeld eerst isoleren en een paar jaar later een warmtepomp aanschaffen. Logische momenten om dat te doen zijn bij een verbouwing of een verhuizing.</p>

<h2><br>
<a class="anchor-link" id="bedrijventerrein" name="Bedrijventerrein" tabindex="-1"></a>Nijverkamp,&nbsp;Het Ambacht,&nbsp;De Batterijen,&nbsp;De Faktorij en De Vendel,&nbsp;De Compagnie,&nbsp;De Compagnie-Oost</h2>

<h3>Wanneer?</h3>

<p>De planning voor de bedrijventerreinen en kantoorgebieden wordt later bepaald.</p>

<h3>Wat gaat er gebeuren?&nbsp;</h3>

<p>De bedrijven- en kantorenterreinen vragen maatwerk, waarbij we bij elk bedrijf apart kijken wat er nodig is. Dit doen wij samen met de bedrijvenverenigingen.&nbsp;<br>
&nbsp;</p>
`
